import Card from "./Card";
import Skeleton from "Components/Common/Skeleton/Skeleton";
import {
  GcProgressDisplayItem,
  formatGcProgressStatus,
} from "../DrawHistory.types";
import EmptyState from "Components/Common/EmptyState";
import NoProgressReports from "Assets/Img/NoProgressReports";

interface ProgressTabProps {
  lineItems: GcProgressDisplayItem[];
  loading: boolean;
}

const ProgressTab = ({ lineItems, loading }: ProgressTabProps) => {
  return (
    <>
      <div className="sectionTitle">GC Self-Reported Progress</div>
      <div className="sectionSub">
        Billing percentage reported by the GC at time of draw submission, per
        SOV line item.
      </div>

      <Card title="SOV Progress — GC's View at Draw Submission">
        {loading ? (
          <div className="progressGrid">
            {Array.from({ length: 6 }).map((_, i) => (
              <div className="progChip" key={i}>
                <Skeleton width={22} height={12} borderRadius={4} />
                <Skeleton
                  width="60%"
                  height={12}
                  borderRadius={4}
                  style={{ flex: 1 }}
                />
                <Skeleton width={60} height={16} borderRadius={10} />
              </div>
            ))}
          </div>
        ) : lineItems.length === 0 ? (
          <EmptyState
            noBorder
            icon={<NoProgressReports />}
            title="No self-reported progress available for this draw."
          />
        ) : (
          <div className="progressGrid">
            {lineItems.map((item) => {
              const status = formatGcProgressStatus(item.status);
              return (
                <div
                  className="progChip"
                  key={item.aiaItemId ?? item.description}
                >
                  <span className="progChipNum">{item.itemCode}</span>
                  <span className="progChipDesc">{item.description}</span>
                  <span className={`progChipStatus ${status.cls}`}>
                    {status.label}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </Card>
    </>
  );
};

export default ProgressTab;
